import { useEffect, useState, useTransition } from 'react';

import { getServiceFeeEligibility, postServiceFeeEligibility } from 'Services/privateApis';

type UseServiceFeeEligibilityProps = {
  dpEnquiryId?: number;
  enabled?: boolean;
  shouldTriggerPost?: boolean;
};

type UseServiceFeeEligibilityReturn = {
  isEligibilityLoading: boolean;
  isEnquiryEligibleForServiceFee: boolean;
};

export const useServiceFeeEligibility = ({
  dpEnquiryId,
  enabled = false,
  shouldTriggerPost = false,
}: UseServiceFeeEligibilityProps = {}): UseServiceFeeEligibilityReturn => {
  const [isEnquiryEligibleForServiceFee, setIsEnquiryEligibleForServiceFee] = useState(false);
  const [isLoading, startTransition] = useTransition();

  useEffect(() => {
    if (!enabled || !dpEnquiryId) {
      return;
    }

    startTransition(async () => {
      await getServiceFeeEligibility(dpEnquiryId)
        .then((response: { eligible?: boolean }) => {
          setIsEnquiryEligibleForServiceFee(Boolean(response?.eligible));
        })
        .catch(() => {
          setIsEnquiryEligibleForServiceFee(false);
        });
    });
  }, [enabled, dpEnquiryId]);

  useEffect(() => {
    if (!shouldTriggerPost || !dpEnquiryId) {
      return;
    }

    startTransition(async () => {
      await postServiceFeeEligibility(dpEnquiryId)
        .then((response: { eligible?: boolean }) => {
          setIsEnquiryEligibleForServiceFee(Boolean(response?.eligible));
        })
        .catch(() => {});
    });
  }, [shouldTriggerPost, dpEnquiryId]);

  return { isEligibilityLoading: isLoading, isEnquiryEligibleForServiceFee };
};
